<template>
  <div class="registrationlink">
      <div class="uyko">
        <div class="center">
            <p>{{$t('other.a539')}}</p>
            
        </div>
        <div >
            <span>{{$t('other.a540')}}：</span>
            <el-input style="width:450px;margin:0 20px;" size="medium" v-model="linkUrl" :placeholder="$t('other.a542')"></el-input>
            <el-button type="primary" size="medium" @click="CopyText()">{{$t('other.a541')}}</el-button>
        </div>
      </div>
  </div>
</template>

<script>
import newOrders from '@/api/moudles/newOrders'
export default {
data(){
return{
    userInfo:JSON.parse(localStorage.getItem('userInfo')),
    linkUrl:''
}
},
created(){
    this.getCode()
},
methods:{

    getCode(){
        if(!this.userInfo){
            this.$message.warning(this.$t('other.a543'))
            return
        }
        newOrders
        .getUserInviteCode({userId:this.userInfo.userId})
        .then(res => {
        if(res.code === 200 ){
            this.linkUrl='https://' + location.host+'/loginPage?invitationCode='+res.data.invitationCode
        console.log('desc',res.data)
        
        
    
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    CopyText(){
        let _input = document.createElement("input");   // 直接构建input
        　　_input.value = this.linkUrl;  // 设置内容
        　　document.body.appendChild(_input);    // 添加临时实例
        　　_input.select();   // 选择实例内容
        　　document.execCommand("Copy");   // 执行复制
        　　this.$message.success(this.$t('other.a544'))
        　　document.body.removeChild(_input); // 删除临时实例
    },

}
}

</script>
<style lang="scss" scoped>
.registrationlink{
    position: relative;
    height: calc(100vh - 60px);

    .uyko{
        text-align: center;
        width: 900px;
        height: 250px;
        position: absolute;
        left: 50%;
        top: 25%;
        transform: translate(-50%,-50%);
        -webkit-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        
    }

    .center{
        margin-bottom: 50px;

        p{
            line-height: 30px;
            color: red;
        }
    }
}
</style>